export default __webpack_public_path__ + "static/media/Helm of the Triumphant.3a5c60c9.jpg";